import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../Image/HouseKeeping/rightthick.png";

const services = [
  "Reception & lobby area cleaning",
  "Executive cabin cleaning",
  "Floor mopping & vacuuming",
  "Common area maintenance",
  "On-demand cleaning teams",
  "Workstation dusting & sanitization",
  "Washroom hygiene management",
  "Window & glass cleaning",
  "Production floor cleaning",
  "Tech enabled solutions",
  "Conference room maintenance",
  "Pantry & cafeteria cleaning",
  "Waste disposal & management",
  "Staircase & corridor upkeep",
];

const steps = [
  {
    number: "01",
    title: "Site Assessment",
    desc: "We evaluate your facility and create a customized cleaning plan.",
  },
  {
    number: "02",
    title: "Team Deployment",
    desc: "Trained and verified staff are deployed with full equipment.",
  },
  {
    number: "03",
    title: "Daily Operations",
    desc: "Daily cleaning in a systematic manner under supervision.",
  },
  {
    number: "04",
    title: "Quality Audits",
    desc: "Regular inspections and feedback-driven improvements.",
  },
];

const HousekeepingServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Housekeeping Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default HousekeepingServices;
